module.exports = __webpack_public_path__ + "img/bugoro_04.ca73efe5.png";